<template>
  <div>
    <div class="card">
      <div class="card-header">
        <h4 class="card-header-title">
          {{ $t('Staff draws') }}
        </h4>
        <router-link
          :to="'/employeesWithdrawals/create?safe_id=' + $route.params.id"
          class="btn btn-sm btn-primary"
          v-if="$parent.item.stat == 1 && $checkRole('employees_withdrawals_add')"
        >
          <i class="fas fa-plus"></i> {{ $t('Addition') }}
        </router-link>
      </div>
      <indexTable
        :searchText="$t('search For A Withdrawal')"
        :emptyTableText="$t('There Are No Withdrawals')"
        :filter="{ safe_id: $route.params.id }"
        :withoutCard="true"
        :emptyTableSubText="$t('Try adding some items to the table and try again')"
        :cloumns="[
          {
            column: 'code',
            title: $t('Withdrawal'),
            type: 'mainLink',
            sort: true
          },
          {
            column: 'employee_id',
            title: $t('Employees name'),
            to: 'employee',
            type: 'link',
            sort: true,
            link: true
          },
          {
            column: 'safe_id',
            title: $t('Treasury'),
            type: 'link',
            to: 'safe',
            sort: true
          },
          {
            column: 'date',
            title: $t('Date'),
            type: 'text',
            sort: true
          },
          {
            column: 'cost',
            title: $t('Cost'),
            type: 'text',
            sort: true
          },
          {
            column: 'description',
            title: $t('Thats about'),
            type: 'text',
            sort: true
          },
          {
            column: 'notes',
            title: $t('Note'),
            type: 'text',
            sort: true
          },

          {
            column: 'options',
            title: $t('Settings'),
            type: 'options',
            options: [
              { name: 'show' },
              {
                name: 'edit',
                role: $checkRole('expenses_edit')
              },
              { name: 'print', role: true },
              { name: 'download', role: true },
              {
                name: 'delete',
                role: $checkRole('expenses_delete')
              }
            ]
          }
        ]"
        :deleteText="{
          attention: $t('Attention'),
          areYouReallySureToDeleteTheItem: $t('Are you really sure to delete the item'),
          close: $t('Close'),
          confirm: $t('Confirm'),
          loading: $t('Loading')
        }"
      />
    </div>
  </div>
</template>
<script>
import indexTable from '@/elements/index/indexTable.vue'
export default {
  data() {
    return {
      path: '/employeesWithdrawals'
    }
  },
  components: {
    indexTable
  }
}
</script>
